module.exports = __webpack_public_path__ + "static/Dishonor-c9a53cc68ec1a1906f11bce7b05df211.png";